<template>
    <div id="notes" style="text-align:left;" class="">
        <div class="" v-if="isDev">
            <a href="#!" @click="backHandler">Back</a><br>
        </div>
        <div style="margin-top:5px;margin-bottom:5px;"
            v-if="isDev">
            <button class="btn" @click="copyEmbeded()">Copy embed</button>
            <button class="btn" @click="copyCodimd()">Copy codimd</button>
            <button class="btn" @click="downloadJSON()">Download JSON</button>
            <button class="btn" @click="copyDBLink()">Copy DBLink</button>
        </div>
        <NotesList v-if="isDev && Object.keys(noteSelected).length == 0 && !edit"
            :notelist="notelist"
            @newpost="newPostHandler"/>
        <NoteDetail v-else-if="Object.keys(noteSelected).length > 0 && !edit"
            @editpost="edit=true"
            :noteSelected="noteSelected"/>
        <NoteEdit v-else-if="edit && isDev"
            :noteSelected="noteSelected"
            @toview="edit=false"/>
        <!-- <NoteEdit v-else-if="edit"
            :noteSelected="noteSelected"
            @toview="edit=false"/> -->
    </div>
</template>

<script>
import NotesList from './NotesList/main'
import NoteDetail from './NoteDetail/main'
import NoteEdit from './NoteEdit/main'

export default {
    name: '',
    components: {
        NotesList,
        NoteDetail,
        NoteEdit,
    },
    computed:{
    },
    data(){
        return {
            search: '',
            noteSelected:  {},
            notelist: [],
            edit: false,
        }
    },
    beforeMount(){
        console.log('this.route', this.$route)
        console.log('notedetail', this.noteSelected)
        if (this.$route.query.jsonurl){
            let url = atob(this.$route.query.jsonurl)
            console.log('url', url)
            this.axios.get(url).then(rs => {
                if (rs.data.crypto){
                    let key = prompt('pass?')
                    key = key.padEnd(16, '*')

                    let encrypted = rs.data.crypto; //python is base64 ECB
                    key = CryptoJS.enc.Utf8.parse(key); 
                    let decrypted =  CryptoJS.AES.decrypt(encrypted, key, {mode:CryptoJS.mode.ECB});
                    let json = decrypted.toString(CryptoJS.enc.Utf8);
                    this.$set(this, 'noteSelected', JSON.parse(json)) 
                }else{
                    this.$set(this, 'noteSelected', rs.data)
                }
            })
        }else{
            this.reloadList()
        }
        window.notesClick = this.notesClick
        window.newPost = this.newPostHandler
    },
    mounted(){
    },
    methods: {
        downloadJSON(){
            this.forceJSONDownload(this.noteSelected, this.noteSelected.key+'.json')
        },
        copyDBLink(){
            this.copyToClipboard(`${window.location.origin}${this.$apiprefix}/get/${this.$col}/${this.noteSelected.key}`)
        },
        copyCodimd(){
            let urlb = btoa(`${this.$apiprefix}/get/${this.$col}/${this.noteSelected.key}`)
            let style = "width:100%;height:600px;border:0;"
            this.copyToClipboard(`<iframe project="crashcode2" style="${style}" src="${window.location.origin}/notes/?jsonurl=${urlb}"></iframe>`)
        },
        copyEmbeded(){
            let urlb = btoa(`${this.$apiprefix}/get/${this.$col}/${this.noteSelected.key}`)
            this.copyToClipboard(`${window.location.origin}/?jsonurl=${urlb}`)
        },
        reloadList(){
            const params = {
                keys: JSON.stringify({title: 1, key: 1}),
            }
            this.axios.get(this.$apiprefix+"/listfull/"+this.$col, {params: params}).then(rs => {
                // this.$set(this, 'notelist', rs.data.sort((a,b) => {
                //     let a2 = a.title.split('/')
                //     let b2 = b.title.split('/')
                //     for (let i = 0; i < Math.max(a2.length, b2.length) ;i++){
                //         if (!a2[i]) return 1
                //         if (!b2[i]) return -1
                //         if (a2[i] == b2[i]) continue
                //         return b2[i] - a2[i]
                //     }

                //     return -1
                // }))
                this.$set(this, 'notelist', rs.data.sort((a,b) => {
                    return a.title.localeCompare(b.title)
                }))
                console.log(this.$route)
                if (this.$route.query.title){
                    console.log(this.notelist)
                    for (let d of this.notelist){
                        console.log(d)
                        if (d.title == this.$route.query.title){
                            this.noteSelected = {
                                key: d.key,
                                title: d.title
                            }
                            break
                        }
                    }
                }
                this.notelist.map(d => {
                    console.log(d.title)
                })
            })
        },
        backHandler(){
            this.reloadList()
            this.noteSelected = {}; 
            this.edit = false;
            window.history.pushState({}, null, window.location.origin+process.env.BASE_URL)
        },
        newPostHandler(title=''){
            this.noteSelected = {
                title: title,
                body: '',
            }
            this.edit = true
        },
        notesClick(node){
            console.log('test trigger', atob(node))
            let node2 = JSON.parse(atob(node))
            window.history.pushState({}, null, `${window.location.origin}/?title=${node2.link.title}`)
            console.log('node2', node2)
            this.noteSelected = node2
        }
    },
}
</script>

<style>
#notes ul {
    list-style-type: circle !important;
}
#notes ul:not(.browser-default) {
	/* padding-left: 30px; */
	/* margin-top: 10px; */
	/* margin-bottom: 15px; */
    margin-left:30px;
}

#notes ul:not(.browser-default) li {
    list-style-type: disc;
}

</style>